import axios from 'axios'

const state = {
  keys: null
}

const getters = {
  StateAPIKeys: state => state.keys,
}

const actions = {
  async CreateAPIKey ({ dispatch }, key) {
    return axios
      .post('api-keys', key)
      .then(response => response)
      .catch(error => { throw(error) })
      .finally(() => {
        dispatch('GetAPIKeys', key.user_id)
      })
  },
  async GetAPIKeys ({ commit }, user_id) {
    const response = await axios.get('api-keys', {params: {user_id: user_id }})
    commit('setKeys', response.data)
  },
  async UpdateAPIKey ({ dispatch }, key) {
    return axios
      .put('api-keys/' + key.id, key)
      .then(response => response)
      .catch(error => { throw(error) })
      .finally(() => {
        dispatch('GetAPIKeys', key.user_id)
      })
  },
  async DeleteAPIKey ({ dispatch }, key) {
    return axios
      .delete('api-keys/' + key.id)
      .then(response => response)
      .catch(error => { throw(error) })
      .finally(() => {
        dispatch('GetAPIKeys', key.user_id)
      })
  }
}

const mutations = {
  setKeys (state, keys) {
    state.keys = keys
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}
